export default {
  screen_log: {
    id: "Id",
    code: "Mã",
    name: "Tên",
    description: "Mô tả",
    active: "Active",
    createdAt: "Tạo lúc",
    updatedAt: "Cập nhật lúc",
    create: "Tạo mới màn hình log",
    update: "Cập nhật màn hình log",
    title: "Chọn màn hình để ghi log",
    caption: "Quản lý Màn hình ghi log",
  }
}